// third-party
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// project imports
// import customerReducer from "./slices/customer";
// import contactReducer from "./slices/contact";
// import productReducer from "./slices/product";
// import chatReducer from "./slices/chat";
// import calendarReducer from "./slices/calendar";
// import mailReducer from "./slices/mail";
// import kanbanReducer from "./slices/kanban";

import snackbarReducer from "./slices/snackbar";
import cartReducer from "./slices/cart";
import menuReducer from "./slices/menu";
import accountReducer from "./accountReducer";
import playerReducer from "./playerReducer";
import alertReducer from "./alertReducer";
import invitationCodeReducer from "./invitationCodeReducer";
// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  auth: accountReducer,
  player: playerReducer,
  invitationCode: invitationCodeReducer,
  snackbar: snackbarReducer,
  cart: persistReducer(
    {
      key: "cart",
      storage,
      keyPrefix: "berry-",
    },
    cartReducer
  ),
  menu: menuReducer,
  alert: alertReducer,

  // departmentAll: deptReducer,
  // kanban: kanbanReducer,
  // customer: customerReducer,
  // contact: contactReducer,
  // product: productReducer,
  // chat: chatReducer,
  // calendar: calendarReducer,
  // mail: mailReducer,
});

export default reducer;
